import PropTypes from 'prop-types';
import { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import {
	useCreateProductMutation,
	useDeleteProductMutation,
	useGetBrandsFromProductsQuery,
	useGetProductsQuery,
	useGetSuppliersQuery,
	useUpdateProductMutation,
} from '../slices/productsApiSlice';

export const ProductContext = createContext({ products: [] });

const ProductProvider = ({ children }) => {
	const { pathname } = useLocation();
	// 首页不需要全量商品/品牌/供应商，避免与看板接口争带宽
	const skipCatalog = pathname === '/dashboard' || pathname.startsWith('/dashboard/');

	const { data: fetchedProducts = [], isFetching: isFetchingProducts, isLoading: isLoadingProducts, refetch, isError: isLoadingProductsError } = useGetProductsQuery(
		undefined,
		{ skip: skipCatalog },
	);

	const {
		data: fetchedSuppliers = [],
		isFetching: isFetchingSuppliers,
		isLoading: isLoadingSuppliers,
		refetch: refetchSuppliers,
		isError: isLoadingSupplierError,
	} = useGetSuppliersQuery(undefined, { skip: skipCatalog });

	const { data: fetchedBrands = [], isFetching: isFetchingBrands, isLoading: isLoadingBrands, refetch: refetchBrands, isError: isLoadingBrandError } = useGetBrandsFromProductsQuery(
		undefined,
		{ skip: skipCatalog },
	);

	const [createProduct, { isPending: isCreatingProduct }] = useCreateProductMutation();
	const [updateProduct, { isPending: isUpdatingProduct }] = useUpdateProductMutation();
	const [deleteProduct, { isPending: isDeletingProduct }] = useDeleteProductMutation();

	return (
		<ProductContext.Provider
			value={{
				fetchedProducts,
				isLoadingProductsError,
				isLoadingProducts,
				isFetchingProducts,
				refetch,
				createProduct,
				isCreatingProduct,
				updateProduct,
				isUpdatingProduct,
				deleteProduct,
				isDeletingProduct,
				fetchedSuppliers,
				isLoadingSupplierError,
				isFetchingSuppliers,
				isLoadingSuppliers,
				refetchSuppliers,
				fetchedBrands,
				isLoadingBrandError,
				isFetchingBrands,
				isLoadingBrands,
				refetchBrands,
			}}
		>
			{children}
		</ProductContext.Provider>
	);
};

ProductProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export const useProductContext = () => useContext(ProductContext);

export default ProductProvider;
